import { create } from "zustand";

type VerificationStore = {
  selectedAttemptId: string | null;
};

type VerificationActions = {
  setSelectedAttemptId: (id: string) => void;
  clearSelectedAttemptId: () => void;
};

type VerificationState = VerificationStore & VerificationActions;

const useVerificationStore = create<VerificationState>()((set) => ({
  selectedAttemptId: null,
  setSelectedAttemptId: (id) => set({ selectedAttemptId: id }),
  clearSelectedAttemptId: () => set({ selectedAttemptId: null }),
}));

export { useVerificationStore };
